export default "__VITE_ASSET__uL97VBiE__"